export enum TicketActivityType {
    Create,
    Update,
    Delete,
    Assign,
    ChangeStatus,
    AttachmentAdd,
    AttachmentUpdate,
    AttachmentDelete,
    ActivityAdd,
    ActivityUpdate,
    ActivityDelete
}